var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1563,
    height: 417,
    viewBox: "0 0 1563 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 633.003,
    cy: 240.224,
    r: 2.43701,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804.405,
    cy: 185.568,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.64 322.896C847.073 323.592 846.05 323.697 845.354 323.13C844.658 322.564 842.44 319.821 843.007 319.125C843.573 318.429 846.71 320.044 847.406 320.611C848.101 321.177 848.206 322.2 847.64 322.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 780.035,
    cy: 110.834,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 911.633,
    cy: 73.4644,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.431,
    cy: 55.5947,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684.179,
    cy: 164.449,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 903.51,
    cy: 208.313,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 987.994,
    cy: 112.458,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1156.96,
    cy: 318.792,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1213.82,
    cy: 185.568,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634.628,
    cy: 79.4697,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880.764,
    cy: 60.4683,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1078.97,
    cy: 84.8389,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.962,
    cy: 229.435,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082.22,
    cy: 218.061,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.586,
    cy: 21.477,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061.1,
    cy: 143.327,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.505,
    cy: 82.7192,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1018.86,
    cy: 3.60449,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.7,
    cy: 156.323,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1155.33,
    cy: 112.458,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1134.21,
    cy: 144.952,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1134.21,
    cy: 257.287,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1168.59,
    cy: 40.2579,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502.216,
    cy: 159.572,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.817,
    cy: 65.3418,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1437.82,
    cy: 213.991,
    r: 1.62427,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.152,
    cy: 63.3882,
    r: 4.87402,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.492,
    cy: 160.552,
    r: 2.91489,
    transform: "rotate(-180 434.492 160.552)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.687,
    cy: 174.641,
    r: 1.45708,
    transform: "rotate(-180 410.687 174.641)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.811,
    cy: 142.091,
    r: 0.971388,
    transform: "rotate(-180 320.811 142.091)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.811,
    cy: 142.091,
    r: 0.971388,
    transform: "rotate(-180 320.811 142.091)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.386,
    cy: 186.785,
    r: 0.971388,
    transform: "rotate(-180 335.386 186.785)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.683,
    cy: 209.134,
    r: 0.971388,
    transform: "rotate(-180 256.683 209.134)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.542,
    cy: 219.821,
    r: 0.971388,
    transform: "rotate(-180 398.542 219.821)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.712,
    cy: 154.721,
    r: 0.971388,
    transform: "rotate(-180 392.712 154.721)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.542,
    cy: 128.489,
    r: 0.971388,
    transform: "rotate(-180 261.542 128.489)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.017,
    cy: 185.814,
    r: 0.971388,
    transform: "rotate(-180 211.017 185.814)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.967,
    cy: 62.417,
    r: 0.971388,
    transform: "rotate(-180 109.967 62.417)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9606,
    cy: 142.091,
    r: 0.971388,
    transform: "rotate(-180 75.9606 142.091)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.889,
    cy: 196.503,
    r: 0.971388,
    transform: "rotate(-180 420.889 196.503)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1002.53,
    cy: 268.871,
    r: 0.971388,
    transform: "rotate(-180 1002.53 268.871)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 942.125,
    cy: 129.46,
    r: 0.971388,
    transform: "rotate(-180 942.125 129.46)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.932,
    cy: 115.857,
    r: 0.971388,
    transform: "rotate(-180 487.932 115.857)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.1237,
    cy: 236.816,
    r: 0.971388,
    transform: "rotate(-180 36.1237 236.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.961,
    cy: 240.225,
    r: 0.971388,
    transform: "rotate(-180 486.961 240.225)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1502.46,
    cy: 171.241,
    r: 0.971388,
    transform: "rotate(-180 1502.46 171.241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.357,
    cy: 250.914,
    r: 0.971388,
    transform: "rotate(-180 336.357 250.914)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.042,
    cy: 13.7398,
    r: 0.971388,
    transform: "rotate(-180 216.042 13.7398)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.0573,
    cy: 158.601,
    r: 0.971388,
    transform: "rotate(-180 1.0573 158.601)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.939,
    cy: 185.814,
    r: 0.971388,
    transform: "rotate(-180 110.939 185.814)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.57,
    cy: 166.381,
    r: 0.971388,
    transform: "rotate(-180 123.57 166.381)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.946,
    cy: 114.885,
    r: 0.971388,
    transform: "rotate(-180 144.946 114.885)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.3581,
    cy: 8.97759,
    r: 0.971388,
    transform: "rotate(-180 62.3581 8.97759)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.869,
    cy: 147.549,
    r: 0.971388,
    transform: "rotate(-180 493.869 147.549)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.48,
    cy: 163.467,
    r: 0.971388,
    transform: "rotate(-180 604.48 163.467)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1373.23,
    cy: 415.653,
    r: 0.971388,
    transform: "rotate(-180 1373.23 415.653)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.322,
    cy: 105.169,
    r: 2.91489,
    transform: "rotate(-180 166.322 105.169)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.981,
    cy: 172.212,
    r: 2.91489,
    transform: "rotate(-180 177.981 172.212)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.924,
    cy: 244.113,
    r: 2.91489,
    transform: "rotate(-180 316.924 244.113)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.0093,
    cy: 67.276,
    r: 2.91489,
    transform: "rotate(-180 40.0093 67.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.91489,
    transform: "matrix(-1 0 0 1 1559.93 95.3229)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.45708,
    transform: "matrix(-1 0 0 1 1536.12 81.2336)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1446.24 113.783)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1446.24 113.783)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1460.82 69.0893)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 568.369 290.411)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1416.17 56.5667)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 748.736 13.7392)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1386.98 127.386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1282.04 43.8261)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1357.35 30.5715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1294.67 53.9702)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1018.86 56.5668)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1131.62 23.102)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1235.4 193.458)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1201.39 113.783)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1400.58 38.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1458.88 316.196)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1280.1 133.216)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1292.73 88.5219)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1461.79 4.96101)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1317.99 4.96089)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1206.25 96.2939)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 723.924 117.799)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 87.7575 324.638)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1334.51 182.971)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1187.79 246.897)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1556.04 41.8828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1516.2 17.593)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.91489,
    transform: "matrix(-1 0 0 1 1353.46 278.427)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.91489,
    transform: "matrix(-1 0 0 1 564.483 93.38)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.91489,
    transform: "matrix(-1 0 0 1 1442.36 11.7621)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.91489,
    transform: "matrix(-1 0 0 1 1165.44 188.599)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 264.38 37.0249)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 402.112 1.0085)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.971388,
    transform: "matrix(-1 0 0 1 1136.81 32.5147)",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgStars);
export default __webpack_public_path__ + "static/media/bg-stars.9e2ad4e190df1b479e04957072abb1f8.svg";
export { ForwardRef as ReactComponent };